import { formatString } from "@/helpers/formatting";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { IPaginatedResponse } from "@/models/common";
import type {
  ConsentTemplate,
  PayloadConsentTemplate,
  SimpleConsentTemplate,
} from "@/models/consentTemplate";
import type { ConsentOptions } from "@/models/options";

export interface GetConsentTemplatesParams {
  page?: number;
  per_page?: number;
  search?: string;
  client_id?: string;
}

class ConsentTemplateService {
  async getConsentOptions() {
    const response = await axiosClient.get<{ data: ConsentOptions }>(
      endpoints.GET_OPTIONS.CONSENT_TEMPLATES
    );
    return response.data.data;
  }

  async getAllTemplates(params?: GetConsentTemplatesParams) {
    const response = await axiosClient.get<
      IPaginatedResponse<SimpleConsentTemplate>
    >(endpoints.CONSENT_TEMPLATE.ALL, { params });
    return response.data;
  }

  async getTemplate(id: ConsentTemplate["id"]) {
    const response = await axiosClient.get<{ data: ConsentTemplate }>(
      formatString(endpoints.CONSENT_TEMPLATE.SINGLE, id)
    );
    return response.data.data;
  }

  async createTemplate(template: PayloadConsentTemplate) {
    return (
      await axiosClient.post<{ data: ConsentTemplate }>(
        endpoints.CONSENT_TEMPLATE.ALL,
        template
      )
    )?.data.data;
  }

  async updateTemplate(
    template: PayloadConsentTemplate,
    id: ConsentTemplate["id"]
  ) {
    return (
      await axiosClient.put<{ data: ConsentTemplate }>(
        formatString(endpoints.CONSENT_TEMPLATE.SINGLE, id),
        template
      )
    )?.data.data;
  }

  async deleteTemplate(id: ConsentTemplate["id"]) {
    return await axiosClient.delete(
      formatString(endpoints.CONSENT_TEMPLATE.SINGLE, id)
    );
  }
}

const consentTemplateService = new ConsentTemplateService();
export default consentTemplateService;
